<template>
  <section class="py-6 m:py-8 l:py-12">
    <div class="use-cases">
      <div class="use-cases__container container">
        <usecases-image class="use-cases__image-wrapper" />
        <div class="use-cases__more-info">
          <rotating-headers :headers="$t('headers')" />
          <div class="grid">
            <start-trial-button-with-pricing
              event-category="body-20210612-use_cases"
              :signup-route="signupRoute"
              :show-trial-end-date="showTrialEndDate"
              class="use-cases__cta" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UsecasesImage from "./use-cases-image";
import RotatingHeaders from "@/features/rotating-headers/rotating-headers";

import StartTrialButtonWithPricing from "@/shared/start-trial-button-with-pricing";

export default {
  name: "UseCases",
  components: {
    StartTrialButtonWithPricing,
    RotatingHeaders,
    UsecasesImage
  },
  props: {
    showTrialEndDate: {
      type: Boolean,
      default: false
    },
    signupRoute: {
      type: String,
      default: "",
      required: false
    }
  },
  i18n: {
    messages: {
      en: {
        headers: ["Feed your brain while", "Driving", "Commuting", "Doing housework", "Walking", "Relaxing"]
      },
      de: {
        headers: ["Bilde dich weiter", "auf dem Weg zur Arbeit", "im Auto", "bei der Hausarbeit", "beim Spazierengehen", "beim Entspannen"]
      }
    }
  }

};
</script>

<style lang="scss" scoped>

.use-cases {

  &__container {
    @include grid-css;
  }

  &__image-wrapper {

    @include grid-element(12);

    display: flex;
    flex-direction: column;
    align-items: center;

    margin-bottom: $spacing-32;

    @include media(min-width, m) {
      grid-area: 1 / 7 / 1 / 13;
    }

    @include media(min-width, l) {
      @include grid-element(6);
    }
  }

  &__headers {
    @include grid-element(12);

    padding: $spacing-16;

    @include media(min-width,m) {
      grid-area: 1 / 1 / 1 / 8;
    }

    @include media(min-width, l) {
      @include grid-element(5,8);
    }

    @include media(min-width, m) {
      padding: 0;
    }
  }

  &__title {
    @include font-style((xs: h3, m: h2));

    margin-bottom: $spacing-8;

    @include media(min-width,m ) {
      margin-top: $spacing-64;
    }
  }

  &__use-case {
    @include font-style((xs: h3, m: h2), $color: $mid-grey);

    &:not(:last-of-type) {
      margin-bottom: $spacing-8;
    }
  }

  &__cta {
    @include grid-element(12);

    margin-bottom: $spacing-16;

    ::v-deep .start-trial-button-with-pricing__trial-info { /* stylelint-disable-line */
      text-align: center;
      @include media(min-width, m) {
        text-align: left;
      }
    }

    @include media (min-width, m) {
      @include grid-element(8);
    }
  }

  &__more-info {
    @include font-style(caption);

    @include grid-element(12);

    @include media (min-width, m) {
      grid-area: 1 / 1 / 1 / 8;
    }

    @include media (min-width, l) {
      @include grid-element(5,8);
    }

    @include media(min-width, m) {
      text-align: left;
    }
  }
}
</style>
